module.exports = __webpack_public_path__ + "static/img/face-normal.d9bdff74.png";